import React from "react";
import { Link } from "react-router-dom";

import LogoLight from "../assets/images/logo-light.png";
import { useTranslation } from 'react-i18next';

export default function Footer({ hideCta = false }) {
    const { t } = useTranslation();

    return (
        <>
            <footer style={{ background: '#010C66' }} className="pt-16 pb-8">
                <div className="container">
                    {/* CTA band — suppressed when the page has its own CTA section */}
                    {!hideCta && (
                        <div className="text-center mb-14">
                            <h2
                                className="text-white font-bold mb-5"
                                style={{
                                    fontFamily: '"Wix Madefor Display", sans-serif',
                                    fontSize: '1.75rem',
                                }}
                            >
                                {t("Footer.ctaTitle")}
                            </h2>
                            <Link
                                to="/#contact"
                                className="inline-flex items-center justify-center px-7 py-3 rounded-lg font-semibold text-sm transition-all duration-300"
                                style={{
                                    background: '#00C9B1',
                                    color: '#010C66',
                                    fontFamily: '"Inter", sans-serif',
                                }}
                            >
                                {t("CTA.requestDemo")}
                            </Link>
                        </div>
                    )}

                    <div className="h-px mb-10" style={{ background: 'rgba(255,255,255,0.1)' }} />

                    <div className="grid md:grid-cols-12 gap-8 items-start">
                        {/* Logo + description */}
                        <div className="md:col-span-4">
                            <Link to="/" className="inline-block mb-4">
                                <img src={LogoLight} className="h-8 w-auto" alt="ANA Labs" />
                            </Link>
                            <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', lineHeight: 1.7, maxWidth: '260px' }}>
                                {t("Footer.description")}
                            </p>
                        </div>

                        {/* Quick links */}
                        <div className="md:col-span-3">
                            <h5
                                className="font-semibold mb-4 text-sm"
                                style={{ color: 'rgba(255,255,255,0.9)', fontFamily: '"Wix Madefor Display", sans-serif' }}
                            >
                                {t("Footer.quickLinks")}
                            </h5>
                            <ul className="list-none space-y-2">
                                {[
                                    { to: "/#product", label: t("Footer.product") },
                                    { to: "/#industries", label: t("Footer.useCases") },
                                    { to: "/#how-it-works", label: t("Footer.howItWorks") },
                                    { to: "/#about", label: t("Footer.company") },
                                    { to: "/#contact", label: t("Footer.contact") },
                                    { to: "/privacy-policy", label: t("Footer.privacy") },
                                ].map((item, i) => (
                                    <li key={i}>
                                        <Link
                                            to={item.to}
                                            style={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem', textDecoration: 'none' }}
                                            className="hover:text-white transition-colors"
                                        >
                                            {item.label}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Social */}
                        <div className="md:col-span-5">
                            <h5
                                className="font-semibold mb-4 text-sm"
                                style={{ color: 'rgba(255,255,255,0.9)', fontFamily: '"Wix Madefor Display", sans-serif' }}
                            >
                                {t("Footer.followUs")}
                            </h5>
                            <ul className="list-none flex gap-3">
                                {[
                                    { href: "https://linkedin.com/company/ana-labs-technologies", icon: "uil-linkedin", label: "LinkedIn" },
                                    { href: "https://www.facebook.com/share/ih5jDPbRahrcACQn/", icon: "uil-facebook-f", label: "Facebook" },
                                    { href: "https://www.instagram.com/analabs.tech/", icon: "uil-instagram", label: "Instagram" },
                                    { href: "https://twitter.com/analabss", icon: "uil-twitter", label: "Twitter" },
                                ].map((s, i) => (
                                    <li key={i}>
                                        <a
                                            href={s.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-icon btn-sm rounded-md transition-all"
                                            style={{
                                                border: '1px solid rgba(255,255,255,0.15)',
                                                color: 'rgba(255,255,255,0.5)',
                                                background: 'transparent',
                                            }}
                                            title={s.label}
                                        >
                                            <i className={`uil ${s.icon}`}></i>
                                        </a>
                                    </li>
                                ))}
                            </ul>

                            <p
                                className="mt-6 text-xs"
                                style={{ color: 'rgba(255,255,255,0.35)' }}
                            >
                                &copy; {new Date().getFullYear()} ANA Labs. {t("Footer.allRights")}
                            </p>
                            <p
                                className="mt-1 text-xs"
                                style={{ color: 'rgba(255,255,255,0.35)' }}
                            >
                                {t("Footer.legalEntity")}
                            </p>
                        </div>
                    </div>
                </div>
            </footer>

            <a href="#home" id="back-to-top" className="back-to-top fixed hidden text-lg rounded-full z-10 bottom-5 end-5 h-9 w-9 text-center leading-9"
               style={{ background: '#00C9B1', color: '#010C66' }}>
                <i className="uil uil-arrow-up"></i>
            </a>
        </>
    );
}
